/* ==========================================================================
   claude 国家地区 region — 交互
   1. 接管 Dawn 公告条、页脚里的国家选择按钮：捕获阶段拦下点击，改为打开本弹窗。
      语言选择不动。无 JS 或关掉「接管」时，Dawn 原生下拉照常可用。
   2. 弹窗：原生 <dialog>.showModal()；点遮罩、关闭键、Esc 关闭，焦点回到打开它的按钮。
   3. 访客所在国家：取一次 /browsing_context_suggestions.json（不需要 Shopify Plus），本次会话内缓存。
      · 弹窗顶部「推荐」：找到对应那一格，复制到顶部；取不到就不显示。
      · 「其他国家和地区」一格：全球站切到访客所在国家（本店开了、又不归另一站的话），否则保持当前国家；
        欧洲站链回全球站时带上 ?country=访客所在国家。
      · 所有跨站链接都去另一站的对应页面（snippets/claude-store-map，10-21）；只带 utm_* 和搜索词，有严格对应时带锚点；
        没有对应页时带 geo_nomatch=1，目标站静默落地并清理参数。
      · 访客所在国家归另一站时（在「另一站的国家」里，或本店没开且设了引回另一站）：
        提示条（默认）或首次自动跳转。安全措施（Google 不建议按 IP 强制跳转）：
          - 爬虫、预览、测速工具的 UA 不提示、不跳；
          - 访客选过就记住（localStorage geoRegionChoice）：点「留下」、在弹窗里选了本店国家、带 ?country= 进来；
          - 从另一站点过来的（referrer 是另一站）不提示，免得两站来回跳；
          - 自动跳转只跳一次（记 auto），跳过去的地址带 ?country=，对方站把它当成访客的选择；
          - 弹窗里随时能切回去。
   切换国家本身不需要 JS：每格是 localization 表单的提交按钮，或另一站的链接。
   不加 scroll 监听。
   ========================================================================== */

(function () {
  'use strict';

  var COUNTRY_BUTTON = 'localization-form button.localization-form__select';
  var SS_KEY = 'claudeRegionDetected';
  var LS_CHOICE = 'geoRegionChoice';
  var BOT_RE = /bot|crawl|spider|slurp|mediapartners|bingpreview|facebookexternalhit|embedly|quora link preview|whatsapp|telegrambot|skypeuripreview|lighthouse|pagespeed|gtmetrix|headlesschrome|phantomjs|google-inspectiontool|google-read-aloud|petalbot|yandex|baidu|duckduck|applebot/i;

  function activeRoot() {
    return document.querySelector('[data-rg-root]');
  }

  function isCountryButton(btn) {
    var form = btn && btn.closest('form');
    return !!(form && form.querySelector('input[name="country_code"]'));
  }

  function codes(root, attr) {
    return ' ' + (root.getAttribute(attr) || '') + ' ';
  }
  function has(list, iso) {
    return !!iso && list.indexOf(' ' + iso + ' ') !== -1;
  }

  function readLS(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function writeLS(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* 隐私模式等：照常可用，只是不记 */ }
  }

  /* 访客所在国家：{ iso, name }，取不到为 null。同一页只取一次，本次会话缓存 */
  var detectPromise = null;
  function detect() {
    if (detectPromise) return detectPromise;
    var cached = null;
    try { cached = JSON.parse(window.sessionStorage.getItem(SS_KEY) || 'null'); } catch (e) { cached = null; }
    if (cached && cached.iso) { detectPromise = Promise.resolve(cached); return detectPromise; }
    if (!window.fetch || !window.Promise) { detectPromise = { then: function () {} }; return detectPromise; }
    var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
      'browsing_context_suggestions.json?country[enabled]=true';
    detectPromise = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        if (!c || !c.handle) return null;
        var out = { iso: String(c.handle).toUpperCase(), name: c.name || data.detected_values.country_name || '' };
        try { window.sessionStorage.setItem(SS_KEY, JSON.stringify(out)); } catch (e) { /* 隐私模式等 */ }
        return out;
      })
      .catch(function () { return null; });
    return detectPromise;
  }

  /* 这个国家该去另一站吗 */
  function belongsToOther(root, iso) {
    if (!iso || !root.getAttribute('data-rg-base')) return false;
    if (has(codes(root, 'data-rg-other'), iso)) return true;
    return root.getAttribute('data-rg-rest') === 'other' && !has(codes(root, 'data-rg-local'), iso);
  }

  /* 带到另一站的参数：只带营销参数 utm_*（白名单），搜索页再带搜索词 q。
     预览、测试参数、旧 country、variant 一律不带（两店的 variant ID 不通用）。 */
  var KEEP_PARAMS = /^(utm_source|utm_medium|utm_campaign|utm_term|utm_content)$/;
  function carryParams(url) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return url; }
    var extra = [];
    var isSearch = /\/search$/.test(url.split('?')[0]);
    params.forEach(function (value, key) {
      if (KEEP_PARAMS.test(key) || (isSearch && key === 'q')) extra.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    if (!extra.length) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + extra.join('&');
  }

  /* 另一站当前页面的对应地址（10-21）：路径来自 snippets/claude-store-map（data-rg-opath）；
     没有对应页（okind=fallback）时带 geo_nomatch=1，目标站静默落地；有严格对应时保留锚点 */
  function otherUrl(root, iso) {
    var base = root.getAttribute('data-rg-base') || '';
    var path = root.getAttribute('data-rg-opath') || '/';
    var kind = root.getAttribute('data-rg-okind');
    var q = [];
    if (iso) q.push('country=' + encodeURIComponent(iso));
    if (kind === 'fallback') q.push('geo_nomatch=1');
    var url = carryParams(base + path + (q.length ? '?' + q.join('&') : ''));
    if (kind === 'exact' && window.location.hash.length > 1) url += window.location.hash;
    return url;
  }

  /* Liquid 已经输出可用的跨站链接（无 JS 也能用）；有 JS 时补上营销参数和锚点 */
  function decorateLinks(root) {
    var kind = root.getAttribute('data-rg-okind');
    var links = root.querySelectorAll('a[data-rg-out]');
    for (var i = 0; i < links.length; i++) {
      var url = carryParams(links[i].getAttribute('href'));
      if (kind === 'exact' && window.location.hash.length > 1) url += window.location.hash;
      links[i].setAttribute('href', url);
    }
  }

  function open(root, opener) {
    var dlg = root.querySelector('[data-rg-dialog]');
    if (!dlg || dlg.open) return;
    root._rgOpener = opener || null;
    root._rgOpen = true;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var cur = dlg.querySelector('[aria-current="true"]');
    if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
    prepareDialog(root);
  }

  /* 收尾：解锁滚动、还原按钮状态、焦点回到打开它的按钮。
     close() 里直接调用，原生 Esc 关闭时由 close 事件调用；重复调用无副作用 */
  function cleanup(root) {
    if (!root._rgOpen) return;
    root._rgOpen = false;
    document.body.classList.remove('overflow-hidden');
    var op = root._rgOpener;
    root._rgOpener = null;
    if (op) {
      op.setAttribute('aria-expanded', 'false');
      if (document.contains(op)) op.focus();
    }
  }

  function close(root) {
    var dlg = root.querySelector('[data-rg-dialog]');
    if (!dlg) return;
    if (dlg.open && typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    cleanup(root);
  }

  /* ---------- 弹窗里按访客位置的部分 ---------- */
  function showRecommendation(root, iso) {
    var box = root.querySelector('[data-rg-rec]');
    var list = root.querySelector('[data-rg-rec-list]');
    if (!box || !list || !iso) return;
    var tiles = root.querySelectorAll('[data-rg-iso]');
    var hit = null;
    for (var i = 0; i < tiles.length; i++) {
      if (box.contains(tiles[i])) continue;
      var list2 = ' ' + (tiles[i].getAttribute('data-rg-iso') || '') + ' ';
      if (has(list2, iso)) { hit = tiles[i]; break; }
    }
    if (!hit) return;
    var copy = hit.cloneNode(true);
    /* 合成一格复制到推荐里时，带上访客所在国家 */
    if (copy.tagName === 'A' && copy.getAttribute('data-rg-iso').indexOf(' ') !== -1) copy.href = otherUrl(root, iso);
    var li = document.createElement('li');
    li.appendChild(copy);
    list.innerHTML = '';
    list.appendChild(li);
    box.hidden = false;
  }

  function prepareDialog(root) {
    if (root._rgPrepared) return;
    root._rgPrepared = true;
    detect().then(function (found) {
      if (!found) return;
      if (root.getAttribute('data-rg-recommend') === 'true') showRecommendation(root, found.iso);
      /* 合成一格：访客在另一站清单里时带上国家 */
      var tiles = root.querySelectorAll('a[data-rg-out][data-rg-iso]');
      for (var i = 0; i < tiles.length; i++) {
        var list = ' ' + tiles[i].getAttribute('data-rg-iso') + ' ';
        if (list.split(' ').length > 3 && has(list, found.iso)) tiles[i].href = otherUrl(root, found.iso);
      }
      /* 「其他」一格链到另一站时带上访客所在国家 */
      var other = root.querySelector('a[data-rg-other-tile]');
      if (other && belongsToOther(root, found.iso)) other.href = otherUrl(root, found.iso);
    });
  }

  /* 「其他」一格（本站）：换成访客所在国家；不行就只关弹窗，保持当前国家 */
  function onOtherSubmit(root, btn, e) {
    e.preventDefault();
    detect().then(function (found) {
      var iso = found && found.iso;
      var cur = root.getAttribute('data-rg-cur');
      if (iso && iso !== cur && has(codes(root, 'data-rg-local'), iso) && !has(codes(root, 'data-rg-other'), iso)) {
        writeLS(LS_CHOICE, 'stay');
        btn.value = iso;
        var form = btn.form;
        if (form.requestSubmit) form.requestSubmit(btn);
        else { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'country_code'; h.value = iso; form.appendChild(h); form.submit(); }
        return;
      }
      close(root);
    });
  }

  function onEuLocalSubmit(root, btn, e) {
    e.preventDefault();
    writeLS(LS_CHOICE, 'stay');
    detect().then(function (found) {
      var list = ' ' + (btn.getAttribute('data-rg-iso') || '') + ' ';
      if (found && has(list, found.iso)) btn.value = found.iso;
      var form = btn.form;
      if (form.requestSubmit) form.requestSubmit(btn);
      else { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'country_code'; h.value = btn.value; form.appendChild(h); form.submit(); }
    });
  }

  /* ---------- 页头下的提示条 / 首次自动跳转 ---------- */
  function referrerIsOther(root) {
    var base = root.getAttribute('data-rg-base');
    if (!base || !document.referrer) return false;
    try { return new URL(document.referrer).host === new URL(base).host; } catch (e) { return false; }
  }

  /* 无对应页面时静默落地；兼容旧链接，清理标记并保留 initGeo 的防重复切站分支。 */
  function consumeNoMatch(params) {
    if (!params || params.get('geo_nomatch') !== '1') return false;
    try {
      params.delete('geo_nomatch');
      var rest = params.toString();
      window.history.replaceState(window.history.state, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    } catch (e) { /* 改不了地址栏也静默落地 */ }
    return true;
  }

  function initGeo(root) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var noMatch = consumeNoMatch(params);
    var mode = root.getAttribute('data-rg-geo');
    if (!mode || mode === 'off') return;
    if (noMatch) { writeLS(LS_CHOICE, 'stay'); return; }
    /* 带 ?country= 进来（另一站的链接、广告、Google 购物）：当成访客的选择，记住 */
    if (params && params.get('country')) { writeLS(LS_CHOICE, 'stay'); return; }
    if (readLS(LS_CHOICE)) return;
    if (BOT_RE.test(navigator.userAgent || '')) return;
    if (referrerIsOther(root)) { writeLS(LS_CHOICE, 'stay'); return; }

    detect().then(function (found) {
      if (!found || !belongsToOther(root, found.iso)) return;
      var target = otherUrl(root, found.iso);
      if (mode === 'redirect') {
        writeLS(LS_CHOICE, 'auto');
        window.location.replace(target);
        return;
      }
      var bar = root.querySelector('[data-rg-bar]');
      if (!bar) return;
      var text = bar.querySelector('[data-rg-bar-text]');
      var go = bar.querySelector('[data-rg-go]');
      if (text) text.textContent = (text.getAttribute('data-rg-tpl') || '').replace('[country]', found.name || found.iso);
      if (go) {
        go.href = target;
        go.addEventListener('click', function () { writeLS(LS_CHOICE, 'go'); });
      }
      var stay = bar.querySelector('[data-rg-stay]');
      if (stay) stay.addEventListener('click', function () { writeLS(LS_CHOICE, 'stay'); bar.hidden = true; });
      bar.hidden = false;
    });
  }

  /* ---------- 初始化 ---------- */
  function initRegion(root) {
    if (!root || root._rgInit) return;
    root._rgInit = true;
    var dlg = root.querySelector('[data-rg-dialog]');
    if (!dlg) return;

    var onClose = function () { cleanup(root); };
    /* 遮罩：面板铺满弹窗，点到 dialog 本身就是点在遮罩上 */
    var onClick = function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-rg-close]'))) { close(root); return; }
      var otherBtn = e.target.closest && e.target.closest('button[data-rg-other-tile]');
      if (otherBtn) { onOtherSubmit(root, otherBtn, e); return; }
      /* 欧洲站的 EU 一格、当前国家不在它代表的国家里（比如当前是单列的 DE）：访客所在国家在里面就换成它 */
      var euBtn = e.target.closest && e.target.closest('button[data-rg-eu-local]:not([aria-current])');
      if (euBtn) { onEuLocalSubmit(root, euBtn, e); return; }
      /* 在弹窗里选了本店国家：记住，不再按位置提示 */
      if (e.target.closest && e.target.closest('button[name="country_code"]')) writeLS(LS_CHOICE, 'stay');
    };
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('click', onClick);

    /* 被接管的 Dawn 按钮：读屏知道它会打开弹窗 */
    if (root.getAttribute('data-rg-intercept') === 'true') {
      var btns = document.querySelectorAll(COUNTRY_BUTTON);
      for (var i = 0; i < btns.length; i++) {
        if (!isCountryButton(btns[i])) continue;
        btns[i].setAttribute('aria-haspopup', 'dialog');
        btns[i].setAttribute('aria-controls', dlg.id);
      }
    }

    decorateLinks(root);
    initGeo(root);

    root._rgTeardown = function () {
      dlg.removeEventListener('close', onClose);
      dlg.removeEventListener('click', onClick);
      close(root);
      delete root._rgInit;
      delete root._rgTeardown;
      delete root._rgPrepared;
    };
  }

  /* 捕获阶段在 document 上拦截：先于 Dawn 绑在按钮上的监听执行 */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(COUNTRY_BUTTON) : null;
    if (!btn || !isCountryButton(btn)) return;
    var root = activeRoot();
    if (!root || root.getAttribute('data-rg-intercept') !== 'true' || !root.querySelector('[data-rg-dialog]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(root, btn);
  }, true);

  function initAll() {
    var roots = document.querySelectorAll('[data-rg-root]');
    for (var i = 0; i < roots.length; i++) initRegion(roots[i]);
  }

  function rootOf(t) { return t && t.querySelector ? t.querySelector('[data-rg-root]') : null; }

  document.addEventListener('shopify:section:load', function (e) {
    var r = rootOf(e.target); if (r) initRegion(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = rootOf(e.target); if (r && r._rgTeardown) r._rgTeardown();
  });
  /* 编辑器里选中本分区时打开弹窗，取消选中时关上 */
  document.addEventListener('shopify:section:select', function (e) {
    var r = rootOf(e.target); if (r) { initRegion(r); open(r, null); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var r = rootOf(e.target); if (r) close(r);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
